import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { getAccommodationTypes } from "../../services/AccommodationTypeService";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const TypeOfAccommodation = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const fadeUp = {
    hidden: { opacity: 0, y: 60 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getAccommodationTypes();
        if (res.data?.success && res.data) {
          setItems(res.data?.data);
        }
      } catch (err) {
        console.error("Failed to fetch accommodation types:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  return (
    <Box
      ref={ref}
      component={motion.div}
      variants={fadeUp}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      sx={{ py: { xs: 2, sm: 2, md: 3 }, backgroundColor: "#fff" }}>
      <Container sx={{
        px: { xs: 3, sm: 4, md: 6 },
        paddingLeft: { xs: "24px !important", md: "48px !important" },
        paddingRight: { xs: "24px !important", md: "48px !important" }
      }}>
        <Box
          sx={{
            display: "inline-block",
            position: "relative",
            mb: 2,

            "&::after": {
              content: '""',
              position: "absolute",
              left: 0,
              bottom: -8,
              width: "200px",
              height: "2px",
              backgroundColor: "#fd0000",
              opacity: "0.5"
            },
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontWeight: 800,
              fontSize: { xs: "22px", sm: "26px", md: "30px" },
              color: "#000",              
            }}
          >
            Types Of Accommodation
          </Typography>
        </Box>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Grid container sx={{mt: { xs: 2, md: 2 },}} spacing={{ xs: 3, md: 4 }} justifyContent={'center'}>
            {items.map((it, idx) => (
              <Grid
                component={motion.div}
                variants={fadeUp}
                initial="hidden"
                animate={inView ? "visible" : "hidden"}
                transition={{ delay: idx * 0.15 }}
                key={idx} size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Box
                    component={motion.img}
                    whileHover={{ scale: 1.05 }}
                    src={it.image}
                    alt={`${it.title}`.trim()}
                    sx={{
                      marginBottom: '15px',
                      width: "100%",
                      height: "290px",
                      aspectRatio: "4 / 3",
                      objectFit: "cover",
                      borderRadius: "16px",
                      boxShadow: "0 1px 0 rgba(0,0,0,0.02)",
                    }}
                  />
                  <Typography
                    sx={{
                      textAlign: "center",
                      textTransform:'capitalize',
                      color: "#000",
                      fontWeight: 700,
                      fontSize: { xs: 14, md: 16 },
                      lineHeight: 1.3,
                    }}
                  >
                    {it.title}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </Box>
  );
};

export default TypeOfAccommodation;
